/* eslint-disable camelcase */
<template>
  <b-modal
    id="modal1"
    ref="modal"
    cancel-variant="outline-danger"
    cancel-title="キャンセル"
    ok-title="フィルターしてダウンロード"
    title="CSV出力項目"
    @ok.prevent="fetchData"
    @hidden="hideFilterModal"
    size="lg"
    modal-class="modal-filter"
  >
    <div class="custom-form-block filter-form reg-form">
      <div class="form-group row">
        <div class="col-md-6">
          <b-form-checkbox
            id="checkbox-0"
            v-model="checkAllValue"
            name="check_all"
            value="true"
            @change="checkboxSelect"
          >
            {{ checkAllValue ? '一括解除' : '一括選択' }}
          </b-form-checkbox>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-1"
            v-model="selectedCheckboxes"
            name="registration_date"
            value="registration_date"
            >登録 / 更新日</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-2"
            v-model="selectedCheckboxes"
            name="name"
            value="name"
            unchecked-value="null"
            >氏名</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-3"
            v-model="selectedCheckboxes"
            name="furigana"
            value="furigana"
            unchecked-value="null"
            >ふりがな</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-4"
            v-model="selectedCheckboxes"
            name="gender"
            value="gender"
            unchecked-value="null"
            >性別</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-5"
            v-model="selectedCheckboxes"
            name="dob"
            value="dob"
            unchecked-value="null"
            >生年月日</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-28"
            v-model="selectedCheckboxes"
            name="age"
            value="age"
            unchecked-value="null"
            >年齢</b-form-checkbox
          >
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-7"
            v-model="selectedCheckboxes"
            name="email"
            value="email"
            unchecked-value="null"
            >メールアドレス</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-6"
            v-model="selectedCheckboxes"
            name="residence"
            value="residence"
            unchecked-value="null"
            >居住地</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-8"
            v-model="selectedCheckboxes"
            name="final_education"
            value="final_education"
            unchecked-value="null"
            >最終学歴</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-9"
            v-model="selectedCheckboxes"
            name="graduation_school"
            value="graduation_school"
            unchecked-value="null"
            >卒業学校</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-10"
            v-model="selectedCheckboxes"
            name="graduation_dept"
            value="graduation_dept"
            unchecked-value="null"
            >卒業学部</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-11"
            v-model="selectedCheckboxes"
            name="graduation_year"
            value="graduation_year"
            unchecked-value="null"
            >卒業年</b-form-checkbox
          >
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-12"
            v-model="selectedCheckboxes"
            name="recent_company"
            value="recent_company"
            unchecked-value="null"
            >直近在籍企業名</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-13"
            v-model="selectedCheckboxes"
            name="years_of_attendance"
            value="years_of_attendance"
            unchecked-value="null"
            >在籍期間</b-form-checkbox
          >
        </div>

        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-20"
            v-model="selectedCheckboxes"
            name="current_emp_status"
            value="current_emp_status"
            unchecked-value="null"
            >就業状況</b-form-checkbox
          >
        </div>

        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-15"
            v-model="selectedCheckboxes"
            name="employment_status"
            value="employment_status"
            unchecked-value="null"
            >雇用形態</b-form-checkbox
          >
        </div>

        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-19"
            v-model="selectedCheckboxes"
            name="no_of_exp_companies"
            value="no_of_exp_companies"
            unchecked-value="null"
            >経験社数</b-form-checkbox
          >
        </div>

        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-17"
            v-model="selectedCheckboxes"
            name="english_skills"
            value="english_skills"
            unchecked-value="null"
            >英語力</b-form-checkbox
          >
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-14"
            v-model="selectedCheckboxes"
            name="lastJob"
            value="lastJob"
            unchecked-value="null"
            >直近職種</b-form-checkbox
          >
        </div>

        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-18"
            v-model="selectedCheckboxes"
            name="last_year_income"
            value="last_year_income"
            unchecked-value="null"
            >年収</b-form-checkbox
          >
        </div>

        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-16"
            v-model="selectedCheckboxes"
            name="position"
            value="position"
            unchecked-value="null"
            >役職</b-form-checkbox
          >
        </div>

        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-21"
            v-model="selectedCheckboxes"
            name="job_summary"
            value="job_summary"
            unchecked-value="null"
            >職務要約</b-form-checkbox
          >
        </div>

        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-22"
            v-model="selectedCheckboxes"
            name="resumeContent"
            value="resumeContent"
            unchecked-value="null"
            >職務経歴書情報</b-form-checkbox
          >
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-29"
            v-model="selectedCheckboxes"
            name="careerChange"
            value="careerChange"
            unchecked-value="null"
            >配慮事項</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-26"
            v-model="selectedCheckboxes"
            name="companyFrom"
            value="companyFrom"
            unchecked-value="null"
            >経由</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-27"
            v-model="selectedCheckboxes"
            name="scouted_jobs"
            value="scouted_jobs"
            unchecked-value="null"
            >スカウト希望</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-25"
            v-model="selectedCheckboxes"
            name="status"
            value="status"
            unchecked-value="null"
            >ステータス</b-form-checkbox
          >
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-55"
            v-model="selectedCheckboxes"
            name="favorite"
            value="favorite"
            unchecked-value="null"
            class="capitalize"
          >
            ブックマーク</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-24"
            v-model="selectedCheckboxes"
            name="memo"
            value="memo"
            unchecked-value="null"
            >メモ</b-form-checkbox
          >
        </div>
        <div class="col-md-2">
          <b-form-checkbox
            id="checkbox-46"
            v-model="selectedCheckboxes"
            name="eventParticipation"
            value="eventParticipation"
            unchecked-value="null"
            >申込イベント</b-form-checkbox
          >
        </div>
      </div>
      <div>
        <!-- <div>メモ
          Selected:
          <strong>{{ name }}</strong>
        </div>-->
      </div>
    </div>
    <template #modal-footer>
      <button class="btn btn-white" @click="hideFilterModal">
        キャンセル
      </button>
      <button class="btn btn-blue" @click="fetchData">
        CSV出力する
      </button>
    </template>
  </b-modal>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import mutations from '@/config/mutations';
import actions from '@/config/actions';
import moment from 'moment';
import Api from '@/config/api';
import ApiService from '@/service/apiService';

export default {
  name: 'FilterForm',
  data() {
    return {
      checkAllValue: false,
      checkboxes: [
        'registration_date',
        'name',
        'furigana',
        'gender',
        'dob',
        'age',
        'residence',
        'email',
        'final_education',
        'graduation_school',
        'graduation_dept',
        'graduation_year',
        'recent_company',
        'lastJob',
        'years_of_attendance',
        'employment_status',
        'position',
        'english_skills',
        'last_year_income',
        'no_of_exp_companies',
        'current_emp_status',
        'job_summary',
        'resumeContent',
        'memo',
        'status',
        'companyFrom',
        'scouted_jobs',
        'favorite',
        'interview',
        'careerChange',
        'eventParticipation',
      ],
      selectedCheckboxes: [],
      registration_date: false,
      name: false,
      furigana: false,
      gender: false,
      dob: false,
      age: false,
      residence: false,
      email: false,
      final_education: false,
      graduation_school: false,
      graduation_dept: false,
      graduation_year: false,
      recent_company: false,
      lastJob: false,
      years_of_attendance: false,
      employment_status: false,
      position: false,
      english_skills: false,
      last_year_income: false,
      no_of_exp_companies: false,
      current_emp_status: false,
      job_summary: false,
      memo: false,
      status: false,
      companyFrom: false,
      favorite: false,
      interview: false,
      careerChange: false,
    };
  },
  watch: {
    showModal(val) {
      if (val) this.$refs.modal.show();
      this.$refs.modal.hide();
    },
  },
  computed: {
    // ...mapGetters({
    //   all: "getAll"
    // }),
    ...mapState({
      showModal: ({ applicant }) => applicant.showFilterModal,
      searchParams: ({ applicant }) => applicant.searchParams,
      sortBy: ({ applicant }) => applicant.sortBy,
      favoritesOnly: ({ applicant }) => applicant.favoritesOnly,
      interviewsOnly: ({ applicant }) => applicant.interviewsOnly,
    }),
  },
  methods: {
    hasValue(value) {
      return this.selectedCheckboxes.includes(value);
    },
    ...mapMutations([mutations.applicant.TOGGLE_FILTER_MODAL]),
    ...mapActions([actions.applicant.LOAD_SELECTORS]),
    hideFilterModal() {
      this[mutations.applicant.TOGGLE_FILTER_MODAL](false);
    },
    buildParams(page = null) {
      const params = {};
      if (this.favoritesOnly) params.favorites = this.favoritesOnly;
      if (this.interviewsOnly) params.interviews = this.interviewsOnly;
      if (this.searchParams) Object.assign(params, this.searchParams);
      if (this.sortBy) params.sort = this.sortBy;
      return params;
    },
    async fetchData() {
      this.hideFilterModal();

      try {
        const response = await ApiService.get(
          Api.endpoints.ALLAPPLICANTS,
          {},
          this.buildParams()
        );
        // console.log(response.data.data);
        // const newdata = this.parseFetchData(response.data.data);
        // console.log(newdata);
        // return newdata;
        this.parseCsvContent(response.data.data);
        // return response.data.data;
        // const response = await axios.get('https://holidayapi.com/v1/holidays?key=a4b2083b-1577-4acd-9408-6e529996b129&country=US&year=2017&month=09');
        // console.log(response);
        // return response.data.holidays;
        this.clearForm();
      } catch (error) {
        this.parseErrorResponse(error.response);
      }
    },
    parseCsvContent(applicants) {
      let csvContent = `${
        this.hasValue('registration_date') ? '登録 / 更新日,' : ''
      }${this.hasValue('name') ? '氏名,' : ''}${
        this.hasValue('furigana') ? 'ふりがな,' : ''
      }${this.hasValue('gender') ? '性別,' : ''}${
        this.hasValue('dob') ? '生年月日,' : ''
      }${this.hasValue('age') ? '年齢,' : ''}${
        this.hasValue('email') ? 'メールアドレス,' : ''
      }${this.hasValue('residence') ? '居住地,' : ''}${
        this.hasValue('final_education') ? '最終学歴,' : ''
      }${this.hasValue('graduation_school') ? '卒業学校,' : ''}${
        this.hasValue('graduation_dept') ? '卒業学部,' : ''
      }${this.hasValue('graduation_year') ? '卒業年,' : ''}${
        this.hasValue('recent_company') ? '直近在籍企業名,' : ''
      }${this.hasValue('years_of_attendance') ? '在籍期間,' : ''}${
        this.hasValue('current_emp_status') ? '就業状況,' : ''
      }${this.hasValue('employment_status') ? '雇用形態,' : ''}${
        this.hasValue('no_of_exp_companies') ? '経験社数,' : ''
      }${this.hasValue('english_skills') ? '英語力,' : ''}${
        this.hasValue('lastJob') ? '直近職種,' : ''
      }${this.hasValue('last_year_income') ? '年収,' : ''}${
        this.hasValue('position') ? '役職,' : ''
      }${this.hasValue('job_summary') ? '職務要約,' : ''}${
        this.hasValue('resumeContent') ? '職務経歴書情報,' : ''
      }${this.hasValue('careerChange') ? '配慮事項,' : ''}${
        this.hasValue('companyFrom') ? '経由,' : ''
      }${this.hasValue('scouted_jobs') ? 'スカウト希望,' : ''}${
        this.hasValue('status') ? 'ステータス,' : ''
      }${this.hasValue('favorite') ? 'ブックマーク,' : ''}${
        this.hasValue('memo') ? 'メモ,' : ''
      }${this.hasValue('eventParticipation') ? '申込イベント' : ''}\n`;

      applicants.forEach((applicant) => {
        csvContent += this.parseApplicant(applicant);
      });

      const link = window.document.createElement('a');
      link.setAttribute(
        'href',
        `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURIComponent(csvContent)}`
      );
      link.setAttribute(
        'download',
        `jobSeekers-${moment().format('YYYY-MM-DD')}.csv`
      );
      link.click();
      return 0;
    },
    parseApplicant(applicant) {
      const {
        joinedDate,
        name,
        last_name,
        furigana,
        last_furigana,
        gender,
        birthDate,
        age,
        residence,
        email,
        education,
        employment,
        memo,
        status,
        companyFrom,
        isFavorite,
        eventParticipation,
        scouted_jobs,
      } = applicant;

      return `${
        this.hasValue('registration_date')
          ? `${moment(joinedDate)
              .format('YYYY-MM-DD')
              .toString()},`
          : ''
      }${
        this.hasValue('name')
          ? `${
              last_name == undefined || last_name == '' || last_name == null
                ? ''
                : last_name
            } ${this.checkUndefined(name)},`
          : ''
      }${
        this.hasValue('furigana')
          ? `${
              last_furigana == undefined ||
              last_furigana == '' ||
              last_furigana == null
                ? ''
                : last_furigana
            } ${this.checkUndefined(furigana)},`
          : ''
      }${this.hasValue('gender') ? `${this.checkUndefined(gender)},` : ''}${
        this.hasValue('dob')
          ? `${this.checkUndefined(moment(birthDate).format('YYYY-MM-DD'))},`
          : ''
      }${this.hasValue('age') ? `${this.checkUndefined(age)},` : ''}${
        this.hasValue('email') ? `${this.checkUndefined(email)},` : ''
      }${
        this.hasValue('residence')
          ? `${this.checkUndefined(this.checkAttribute(residence))},`
          : ''
      }${
        this.hasValue('final_education')
          ? `${this.checkUndefined(this.checkAttribute(education.last))},`
          : ''
      }${
        this.hasValue('graduation_school')
          ? `${this.checkUndefined(education.instituteName)},`
          : ''
      }${
        this.hasValue('graduation_dept')
          ? `${this.checkUndefined(education.department)},`
          : ''
      }${
        this.hasValue('graduation_year')
          ? `${this.checkUndefined(education.graduateYear)},`
          : ''
      }${
        this.hasValue('recent_company')
          ? `${this.checkUndefined(this.myTrim(employment.lastCompany))},`
          : ''
      }${
        this.hasValue('years_of_attendance')
          ? `${this.checkUndefined(employment.yearsAttended)},`
          : ''
      }${
        this.hasValue('current_emp_status')
          ? `${this.checkUndefined(applicant.employment.employmentSituation)},`
          : ''
      }${
        this.hasValue('employment_status')
          ? `${this.checkUndefined(
              this.checkAttribute(applicant.employment.status)
            )},`
          : ''
      }${
        this.hasValue('no_of_exp_companies')
          ? `${this.checkUndefined(applicant.employment.experienceCompanies)},`
          : ''
      }${
        this.hasValue('english_skills')
          ? `${this.checkUndefined(
              this.checkAttribute(applicant.employment.englishSkill)
            )},`
          : ''
      }${
        this.hasValue('lastJob')
          ? `${this.checkUndefined(
              this.checkAttribute(employment.lastJob)
            )}(${this.checkUndefined(
              this.checkAttribute(applicant.employment.lastJob.child)
            )}),`
          : ''
      }${
        this.hasValue('last_year_income')
          ? `${this.checkUndefined(applicant.employment.lastYearIncome)},`
          : ''
      }${
        this.hasValue('position')
          ? `${this.checkUndefined(this.checkAttribute(employment.position))},`
          : ''
      }${
        this.hasValue('job_summary')
          ? `${this.checkUndefined(this.myTrim(applicant.employment.summary))},`
          : ''
      }${
        this.hasValue('resumeContent')
          ? `${this.checkUndefined(employment.resumeContent)},`
          : ''
      }${
        this.hasValue('careerChange')
          ? `${this.checkUndefined(
              this.myTrim(employment.career_change_reason)
            )},`
          : ''
      }${
        this.hasValue('companyFrom')
          ? `${this.checkUndefined(companyFrom)},`
          : ''
      }${
        this.hasValue('scouted_jobs')
          ? scouted_jobs && scouted_jobs.length > 0
            ? 'Yes,'
            : 'No,'
          : ''
      }${this.hasValue('status') ? `${this.checkUndefined(status)},` : ''}${
        this.hasValue('favorite')
          ? this.checkUndefined(isFavorite)
            ? 'Yes,'
            : 'No,'
          : ''
      }${
        this.hasValue('memo')
          ? `${this.checkUndefined(this.myTrim(memo))},`
          : ''
      }${
        this.hasValue('eventParticipation')
          ? this.checkUndefined(eventParticipation)
            ? 'Yes'
            : 'No'
          : ''
      }\n`;
    },
    checkUndefined(value) {
      if (value === undefined || value === null) {
        return '';
      }
      // For resume content, preserve line breaks but escape properly for CSV
      if (typeof value === 'string' && value.includes('\n')) {
        // Escape quotes by doubling them (CSV standard)
        // Wrap in quotes to preserve line breaks
        return `"${value.replace(/"/g, '""')}"`;
      }
      return value;
    },
    checkAttribute(attribute, property = 'title') {
      if (attribute && attribute[property]) return attribute.title;
      return 'N/A';
    },
    checkboxSelect(value) {
      this.selectedCheckboxes = value ? this.checkboxes.slice() : [];
    },
    myTrim(x = '') {
      const temp = x.replace(/\"/g, '""');
      if (temp == '') return '';
      return `"${temp}"`;
      // return "\""+temp.replace(/^\s+|\s+$/gm,'')+"\"";
    },
    clearForm() {
      this.selectedCheckboxes = [];
      this.checkAllValue = false;
    },
  },
};
</script>
<style>
.modal-filter .modal-header {
  border: none;
  font-weight: bold;
}

.modal-filter .modal-footer {
  border: none;
  justify-content: center;
  gap: 40px;
}
.reg-form h3 {
  text-transform: uppercase;
  color: #2bb2ab;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 8px;
}

.reg-form h3 a {
  text-transform: uppercase;
  color: #2bb2ab;
  font-weight: 600;
  font-size: 13px;
}

.reg-form h3 a:hover,
.reg-form h3 a:focus {
  color: #1b7c77;
}

.reg-form .form-check-inline {
  margin-bottom: 7px;
}

.reg-form .form-check-inline .form-check-input {
  margin-top: -2px;
}

.mb-20 {
  margin-bottom: 20px;
}
.modal-content {
  background-color: #fbfcff;
}
.modal-search .modal-title {
  font-size: 15px;
  font-weight: bold;
}

.modal-search .modal-header,
.modal-search .modal-footer {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.sub-head {
  color: #89969f;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 7px;
  padding-top: 10px;
}
.btn-rmv {
  background: transparent;
  padding-right: 15px;
  font-size: 20px;
  color: #31bab4;
  border: none;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  outline: none !important;
  cursor: pointer;
  z-index: 99;
}
.capitalize label {
  text-transform: capitalize !important;
}
/* .bnt-grp button */
</style>
